<template>
  <div class="section-container">
    <div class="main-container">
      <div class="type-wrap">
        <router-link to="/" class="home-page">首页></router-link>
        <span class="type-name">关于我们</span>
      </div>
      <div class="page__title">
        <h2 class="large__title">{{aboutUs[0]}}</h2>
        <h4 class="small__title square">{{aboutUs[1]}}</h4>
      </div>
      <div class="about-introduction">
        <div class="text-indent" v-html="itemList[0].content"></div>
      </div>
      <div class="paragraph-wrapper" v-for="(item,index) in itemList" v-if="index > 0">
        <div class="item">
          <h4 class="item-title">{{item.title}}</h4>
          <div class="row row-indent" v-html="item.content"></div>
        </div>
      </div>
      <div class="page-caption">
        <div class="point"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Company',
    data () {
      return {
        itemList: {},
        aboutUs: []
      }
    },
    created () {
      this.getItemList()
    },
    mounted () {
      this.getItemList()
    },
    methods: {
      getItemList () {
        let vm = this
        this.$http({
          url: '/getAboutUsArticleInfo.jhtml',
          data: {
            type: 5
          },
          done (result) {
            vm.itemList = [].concat(result)
            vm.aboutUs = vm.itemList[0].title.split('-')
          }
        })
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.main-container
  padding-top 46px
  .small__title
    padding-left 108px
.about-introduction
  position relative
  padding 20px 0 40px
  font-size 18px
  color rgb(51, 51, 51)
  font-weight 600
  background-image url("/static/img/about.png")
  background-repeat no-repeat
  background-position 970px 280px
  .text-indent
    margin 0
    line-height 2
    text-indent 2em
    letter-spacing 1px
.paragraph-wrapper
  border none
.row-indent
  margin-left 2rem
  margin-bottom 38px

.common-margin
  width 47%
  &:nth-child(1)
    float left
  &:nth-child(2)
    float right
  .company-name
    font-weight bold
    font-family MicrosoftYaHei
    color #333
  p
    margin-bottom 16px

.type-wrap
  position absolute
  top 24px
  font-size 12px
  span
    color #333
  .type-name
    font-family MicrosoftYaHei
    color #2b9efc
  .home-page
    text-decoration none
    color #333

.item-title
  margin-bottom 30px
</style>



// WEBPACK FOOTER //
// company.vue?219de09c